<template>
  <div class="groupDynamic">
    <Animate ref="animate" />

    <dynamic-item :dynamics="dynamicData"></dynamic-item>

    <pagination ref="paging" @pagingChange="pagingChange" :total="count"></pagination>
  </div>
</template>

<script>

  import {ref, reactive, getCurrentInstance, onMounted} from 'vue'
  import { queryDynamic, totalDynamic } from '@/network/dynamic'
  import {ElMessage, ElMessageBox} from 'element-plus/lib/components'
  import Animate from "@/components/common/Animate";

  import DynamicItem from "../childComps/DynamicItem";
  import Pagination from "@/components/common/Pagination";

  export default {
    name: "GroupDynamic",
    components:{
      DynamicItem,
      Pagination,
      Animate,
    },
    setup(){

      let instance = reactive({});
      instance = getCurrentInstance();
      // 合作信息的总数
      let count = ref(0);
      let dynamicData = reactive([])


      onMounted(() => {
        totalDynamic().then(res => {
          if (res.state === 200){
            count.value = res.data;                                 //用props传参不好用,不知道为啥
            instance.proxy.$refs.paging.pagination.total = res.data;  //这个方案好用
          }
        })
        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      })


      //methods
      // 页面加载即请求数据
      queryDynamic(0, 20).then(result => {
        if (result.state === 200){
          result.data.forEach(item => dynamicData.push(item));
        } else if (result.state === '50000'){
          router.push('/regLogin');
          ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
        }
      })
      // 分页变化
      function pagingChange(pageSize, currentPage) {
        let length = 0;
        dynamicData.length = 0;
        if ((currentPage - 1) * pageSize + pageSize > count.value)
          length = count.value - (currentPage - 1) * pageSize;
        else length = pageSize;
        queryDynamic((currentPage - 1) * pageSize, length).then(res => {
          if (res.state === 200){
            res.data.forEach(item => dynamicData.push(item));
          } else if (res.state === '50000'){
            router.push('/regLogin');
            ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
          }
        })
      }



      return{ dynamicData, count,
        pagingChange
      }

    },//setup
  }
</script>

<style scoped lang="less">

  .groupDynamic{
    padding-bottom: 50px;
  }

  .el-pagination{
    display: flex;
    justify-content: center;
    padding: 40px 20px 50px 0;
  }

</style>